import { FREE_PLAN, STARTER_PLAN, GROWTH_PLAN, PRO_PLAN, ENTERPRISE_PLAN } from '../utils/limits'

export default {
  plans: process.env.REACT_APP_BUILD_ENV === 'development' ? [
    {
      name: FREE_PLAN,
      id: '93107cf02d2546a6a0c4473c7c59fa7b'
    },
    {
      name: STARTER_PLAN, // Essentials
      id: '7c243bc0e1f946bd98b8d0e893e67d45'
    },
    {
      name: PRO_PLAN,
      id: '8cb67532755244c6a8ab5e6d55be2185'
    },
    {
      name: GROWTH_PLAN,
      id: '29882d1dd54840d5b676f12a0e625f5e'
    },
    {
      name: ENTERPRISE_PLAN,
      id: 'f6c9cf18f2104bb0ab51bfa472d7f8cd'
    }
  ] :
    [
    {
      name: FREE_PLAN,
      id: '542f6d07ca4c485ca47fadba319bc21c'
    },
    {
      name: STARTER_PLAN, // Essentials
      id: 'e61e7a2d636d421dbd11e8102133816a'
    },
    {
      name: PRO_PLAN,
      id: '847d1374021946c38017779e52c2481d'
    },
    {
      name: GROWTH_PLAN,
      id: 'f06f16b6a5d14e70a7badf4573baea58'
    },
    {
      name: ENTERPRISE_PLAN,
      id: '01b19429d0c84be8a2cf2f836b338da7'
    }
  ],
  api: {
    middleware: {
      batchHandler: {
        baseUrl: 'https://middleware.rebrandly.com/v1'
      }
    },
    qrcodeGenerator: {
      baseUrl: 'https://qr.rebrandly.com/v1'
    }
  },
  extensions: {
    chrome: {
      url: 'https://chrome.google.com/webstore/detail/rebrandly/eaidebojanpehpceonghnmgdofblnlae',
      id: 'eaidebojanpehpceonghnmgdofblnlae'
    },
    firefox: {
      url: 'https://addons.mozilla.org/firefox/addon/rebrandly/',
      id: '882d8b22-10ae-f949-955a-66c59edc5cc8'
    },
    edge: {
      url: 'https://microsoftedge.microsoft.com/addons/detail/rebrandly-custom-url-sh/megbmimkgjkiaipakfehfphdgojablim',
      id: 'megbmimkgjkiaipakfehfphdgojablim'
    }
  },
  ld: {
    clientId: process.env.REACT_APP_LD_CLIENT_ID,
    sharedKey: 'anonymous-user-id-rbgy'
  },
  dashboardBaseUrl: process.env.REACT_APP_DASH_BASE_URL,
  oauthBaseUrl: process.env.REACT_APP_OAUTH_BASE_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  RbgyFreeTrialClientId: process.env.REACT_APP_NO_PAYMENT_FREE_TRIAL_CLIENT_ID,
  clarityId: process.env.REACT_APP_CLARITY_ID,
  limPanId: process.env.PUBLIC_LIM_PLAN_ID,
  limDealId: process.env.PUBLIC_LIM_DEAL_ID,
  freeTrialPlanId: process.env.PUBLIC_FREE_TRIAL_PLAN_ID
}

